import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { translate } from 'react-i18next';
import i18next from 'i18next';

import DateAndTimePickerField from 'Parts/ui/components/fields/DateAndTimePickerField';

import { getDateValue } from 'Parts/common/dateUtils';

import EventAdminCampaignFields_en from './locales/EventAdminCampaignFields_en.json';
import EventAdminCampaignFields_fr from './locales/EventAdminCampaignFields_fr.json';

import './EventAdminCampaignFields.less';

class EventAdminCampaignFields extends React.Component {
  constructor(props) {
    super(props);

    props.fetchEvent(props.campaign.id, true, { showLocation: true, showSettings: true });

    i18next.addResourceBundle('en', 'EventAdminCampaignFields', EventAdminCampaignFields_en);
    i18next.addResourceBundle('fr', 'EventAdminCampaignFields', EventAdminCampaignFields_fr);
  }

  componentWillUnmount() {
    //this.props.clearEvent();
  }

  render() {
    const { props, state } = this,
      { t, form, Event } = props;

    const startRules = [
      {
        validator: (rule, value, callback) => {
          const past = form.getFieldValue('event_starts') || null;
          const future = form.getFieldValue('event_ends') || null;

          return past === null || future === null || future.diff(past) > 0
            ? callback()
            : callback(true);
        },
        message: t('FIELDS-VALIDATION:date.past', {
          time: getDateValue(form.getFieldValue('event_ends'))
        })
      }
    ];

    const endRules = [
      {
        validator: (rule, value, callback) => {
          const past = form.getFieldValue('event_starts') || null;
          const future = form.getFieldValue('event_ends') || null;

          return past === null || future === null || past.diff(future) < 0
            ? callback()
            : callback(true);
        },
        message: t('FIELDS-VALIDATION:date.future', {
          time: getDateValue(form.getFieldValue('event_starts'))
        })
      }
    ];

    const peerToPastRules = [
      {
        validator: (rule, value, callback) => {
          const past = form.getFieldValue('event_starts') || null;
          const future = form.getFieldValue('event_ends') || null;

          return past === null && future !== null ? callback(true) : callback();
        },
        message: t('select-starts')
      }
    ];

    const peerToFutureRules = [
      {
        validator: (rule, value, callback) => {
          const past = form.getFieldValue('event_starts') || null;
          const future = form.getFieldValue('event_ends') || null;

          return future === null && past !== null ? callback(true) : callback();
        },
        message: t('select-ends')
      }
    ];

    return (
      <div className="EventAdminCampaignFields">
        <DateAndTimePickerField
          form={form}
          fieldId="event_starts"
          label={t('starts')}
          allowClear={true}
          initialValue={get(Event, 'event.startOn', null)}
          //placeholder={}
          //disabled={}
          rules={[...startRules, ...peerToPastRules]}
          onChange={value =>
            this.setState({ past: value }, () => {
              form.validateFields([
                'event_starts_date',
                'event_starts_time',
                'event_ends_date',
                'event_ends_time'
              ]);
            })
          }
        />
        <DateAndTimePickerField
          form={form}
          fieldId="event_ends"
          label={t('ends')}
          allowClear={true}
          initialValue={get(Event, 'event.endOn', null)}
          //placeholder={}
          //disabled={}
          rules={[...endRules, ...peerToFutureRules]}
          onChange={value =>
            this.setState({ future: value }, () => {
              form.validateFields([
                'event_starts_date',
                'event_starts_time',
                'event_ends_date',
                'event_ends_time'
              ]);
            })
          }
        />
      </div>
    );
  }
}

EventAdminCampaignFields.defaultProps = {
  savedValues: {}
};

EventAdminCampaignFields.propTypes = {
  form: PropTypes.object.isRequired,
  //locale: PropTypes.string.isRequired,
  savedValues: PropTypes.object
};

export default translate('EventAdminCampaignFields')(EventAdminCampaignFields);
